import React from "react"
export function NoRefund(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M17.943 1L19 2.06l-.956.954v-.002L5.536 15.52 2.054 19 1 17.946l3.46-3.46a7.207 7.207 0 01-1.717-4.68c0-.34.023-.676.07-1.008h1.516c-.059.33-.088.667-.088 1.008 0 1.37.48 2.63 1.282 3.617l8.075-8.077a5.72 5.72 0 00-3.615-1.28 5.74 5.74 0 00-4.115 1.736h2.596v1.497H4.241a.749.749 0 01-.75-.749V2.315H4.99v2.25a7.235 7.235 0 014.993-1.996c1.784 0 3.417.644 4.678 1.713L17.943 1zm-1.72 11.332c.413 0 .748.335.748.748v4.236h-1.498v-2.792a7.225 7.225 0 01-5.49 2.52 7.214 7.214 0 01-3.142-.716l1.14-1.14a5.732 5.732 0 002.002.358 5.726 5.726 0 004.096-1.717H12v-1.497h4.223zm1-2.526c0 .35-.024.693-.072 1.029h-1.518a5.772 5.772 0 00-.266-3.03l1.14-1.14c.46.95.716 2.015.716 3.141z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__no-refund"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
